import { render, staticRenderFns } from "./SectionReservation.vue?vue&type=template&id=0ac36f9e&scoped=true"
import script from "./SectionReservation.vue?vue&type=script&lang=js"
export * from "./SectionReservation.vue?vue&type=script&lang=js"
import style1 from "./SectionReservation.vue?vue&type=style&index=1&id=0ac36f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac36f9e",
  null
  
)

export default component.exports